'use client';

import dynamic from 'next/dynamic';

import { ProductComparisonSliderType } from '../../../types/storyblok';

export const ProductComparisonSlider = dynamic<ProductComparisonSliderType>(
  async () => import('./ProductComparisonSlider.inner'),
  {
    ssr: true,
  },
);
